import type { FaireProductEntity } from "../../entity_types/product";

export const p_8szcjg6psh: FaireProductEntity = {
  token: "p_8szcjg6psh",
  type: "product",
  name: "FABRIC EMBROIDERED JOURNAL FLOWER MARKET POPPY",
  brandToken: "b_3s38anh4bi",
  brandName: "Lady Jayne",
  imageUrl:
    "https://cdn.faire.com/fastly/6eacfc32b2960b4c16eb6986b32f4b5ff3081e7d15f60826a9ca96c3b6601c54.jpeg",
  galleryImageUrls: [],
  priceDollars: 16.44,
  description:
    'Fabric-wrapped hardcover journal with embroidery. 192 pages.\n6" x 8.5"',
  tags: [],
  msrpDollars: 32.87,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:39.896Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
